
angular.module('component-payments.format.expire.month', [])
	.directive('ctPaymentsFormatExpireMonth', paymentsFormatMonthDirective);

paymentsFormatMonthDirective.$inject = ['CtPayments'];
function paymentsFormatMonthDirective (CtPayments) {
	return {
		restrict: 'A',
		require: 'ngModel',
		template: require('./templates/month.html'),
		link: postLink
	};

	function postLink (scope, elem, attr, ctrl) {
		scope.months = CtPayments.months();
	}
}

module.exports = 'component-payments.format.expire.month';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/formatters/month.js
 ** module id = 92
 ** module chunks = 1
 **/